export default __webpack_public_path__ + "static/media/Social_Linkedin-1.600a4940.svg";